import { Loader } from '@willow/shared-web';

import { CHECKING_TITLE, DEFAULT_HOST_LABEL } from './findPortalCopy';
import { FindPortalLayout } from './FindPortalLayout';

import s from './FindPortal.module.scss';

interface Props {
  email: string;
}

export const CheckingScreen = ({ email }: Props) => (
  <FindPortalLayout
    testId="find-portal-screen-checking"
    documentTitle={CHECKING_TITLE}
    title={CHECKING_TITLE}
    description={email || DEFAULT_HOST_LABEL}
  >
    <div className={s.spinner}>
      <Loader />
    </div>
  </FindPortalLayout>
);
